import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import {getStorage} from "firebase/storage"
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAaRtxx5ZlNtlCVhervG4wyTlu_qYV_k18",
  authDomain: "sidewinder-3daf9.firebaseapp.com",
  projectId: "sidewinder-3daf9",
  storageBucket: "sidewinder-3daf9.appspot.com",
  messagingSenderId: "309042078832",
  appId: "1:309042078832:web:5addb5478a5f01ab2d80b5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

export const sendAdultFreeAgentInvite = async ({
  eventID,
  freeAgentUserID,
  teamID,
}: {
  eventID: string;
  freeAgentUserID: string;
  teamID: string;
}) => {
  const sendInvite = httpsCallable(functions, "sendAdultFreeAgentInvite");
  const result = await sendInvite({ eventID, freeAgentUserID, teamID });
  return result.data;
};

export const sendKidsLeagueFreeAgentInvite = async ({
	eventID,
	freeAgentAthleteID,
  teamID,
}: {
  eventID: string;
  freeAgentAthleteID: string;
  teamID: string;
}) => {
  const sendInvite = httpsCallable(functions, "sendKidsLeagueFreeAgentInvite");
	const result = await sendInvite({ eventID, freeAgentAthleteID, teamID });
	return result.data;
};

export const createKidsLeagueTeam = async ({
	athleteID,
	eventID,
	teamName,
}: {
	athleteID: string;
	eventID: string;
	teamName: string;
}) => {
	const createTeam = httpsCallable(functions, "createKidsLeagueTeam");
	const result = await createTeam({ athleteID, eventID, teamName });
	return result.data;
};

export const joinKidsLeagueTeam = async ({
	athleteID,
	eventID,
	teamInviteID,
}: {
	athleteID: string;
	eventID: string;
	teamInviteID: string;
}) => {
	const joinTeam = httpsCallable(functions, "joinKidsLeagueTeam");
	const result = await joinTeam({ athleteID, eventID, teamInviteID });
	return result.data;
};

export const joinKidsLeagueFreeAgentList = async ({
	athleteID,
	eventID,
}: {
	athleteID: string;
	eventID: string;
}) => {
	const joinFreeAgentList = httpsCallable(functions, "joinKidsLeagueFreeAgentList");
	const result = await joinFreeAgentList({ athleteID, eventID });
	return result.data;
};

export const leaveKidsLeagueFreeAgentList = async ({
	athleteID,
	eventID,
}: {
	athleteID: string;
	eventID: string;
}) => {
	const leaveFreeAgentList = httpsCallable(functions, "leaveKidsLeagueFreeAgentList");
	const result = await leaveFreeAgentList({ athleteID, eventID });
	return result.data;
};

export const getAdultRosterProfiles = async (userIDs: string[]) => {
	const getProfiles = httpsCallable(functions, "getAdultRosterProfiles");
	const result = await getProfiles({ userIDs });
  return (result.data as { profiles?: Record<string, unknown> }).profiles ?? {};
};
